<template>
    <div class="card ">
        <div class="card-header bg-default">
            <h3 class="card-title"><i class="far fa-file-alt mr-2"></i>Descripción general</h3>  
            <div class="card-tools">
                <button type="button" class="btn btn-success btn-xs" @click="guardar()">Guardar </button>
            </div>            
        </div>
        <div class="card-body">
            <textarea class="form-control" rows="5" placeholder="Introducir descripción del presupuesto" v-model="descripcionaux.descripcion"></textarea>
        </div>
    </div>    
</template>
<script>
import { PwgsApi } from '../../../../../../services/PwgsApi';

export default ({
    props: ['id', 'seleccionado'],

    data() {
        return {
            descripcionaux: '',
            
        }
    },
    methods: {
        async cargardatos() {

            this.descripcionaux = this.seleccionado;
        },
        async guardar() {
            //PUT  modulos/pwgsapi/index.php/presupuestos/228/modificar-presupuesto
            var descripcion = { descripcion: this.descripcionaux.descripcion };
            try {
                const api = new PwgsApi;
                await api.put('presupuestos/' + this.seleccionado.presupuesto.id_presupuesto + '/modificar-presupuesto', descripcion);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
            }
             catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El trabajo no se puede modificar ya que está incluido en otro presupuesto generado', life: 5000 });
            }
        },
    },
    mounted() {
        this.cargardatos();
    },
    watch: {
        seleccionado() {
            this.cargardatos();
        },


    }
})

</script>